var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":"primary","app":""}},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.appName)+" © 2020")])])}
var staticRenderFns = []

export { render, staticRenderFns }